import { Component, OnInit, ViewChild, ElementRef, Inject, AfterViewInit, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {SeoService} from '../../services/seo.service';
// import { SwiperComponent, SwiperDirective, SwiperModule, SwiperConfigInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { MatStepper } from '@angular/material/stepper';
import disableScroll from 'disable-scroll';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-one',
  templateUrl: './one.component.html',
  styleUrls: ['./one.component.scss']
})
export class OneComponent implements OnInit{

  public itsMobile = false;
  public play:boolean;
  public fixed:boolean;
  public modal1: boolean;
  public initialVideo:boolean;
  public scroll:boolean;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.calcularAltura();
  }

  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  currentIndex = 0;
  scrollSpeed = 4002;
  scrolling = false;

  autoScroll = () => {

    if (this.fixed) {
      return;
    }

    const container = this.scrollContainer.nativeElement;
    const elements = this.el.nativeElement.querySelectorAll('.scroll-auto')

    if (this.currentIndex >= elements.length) {
      this.currentIndex = 0;
    }

    const scrollDistance = elements[this.currentIndex].offsetTop - container.scrollTop;
    const step = Math.ceil(scrollDistance / (this.scrollSpeed / 16));

    const scrollStep = () => {
      if (container.scrollTop === elements[this.currentIndex].offsetTop) {
        this.currentIndex++;
        return;
      }

      if ((scrollDistance > 0 && container.scrollTop < elements[this.currentIndex].offsetTop) ||
          (scrollDistance < 0 && container.scrollTop > elements[this.currentIndex].offsetTop)) {
        container.scrollTop = elements[this.currentIndex].offsetTop;
        this.currentIndex++;
        return;
      }

      container.scrollTop += step;

      requestAnimationFrame(scrollStep);
    }

    requestAnimationFrame(scrollStep);
    setTimeout(this.autoScroll, this.scrollSpeed);
  }

  constructor(private title: Title, private seo: SeoService, private el: ElementRef, public router: Router, @Inject(DOCUMENT) private document: any) { }

  calcularAltura() {
    const myDiv = this.el.nativeElement.querySelector('.viewVisible');
    myDiv.style.height = window.innerHeight + 'px';
  }

  ngOnInit(): void {
    
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    this.document.documentElement.classList.add('hide-Chat');

    this.calcularAltura();

    const t = 'gennius.xyz - Building Human-to-Human technologies';
    this.title.setTitle(t);

    this.seo.generateTags({
      title: 'gennius.xyz - Building Human-to-Human technologies',
      keyword: 'rewards, cryptocurrencies, crypto, cashback, points, miles, digital card, digital payment, loyalty rewards, redemptions, digital assets, bank cards, bank directs, smart payments, virtual card, metaverse, NFT',
      // tslint:disable-next-line:max-line-length
      description: "Empowering rewards and Web3 platforms to create superior user experiences and bring digital engagement and loyalty to new levels.",
      image: 'https://gennius.xyz/assets/img/gennius/share-gennius.jpg'
    });

    /* const canvas = document.getElementById('canvas3d') as HTMLCanvasElement;
    const app = new Application(canvas);
    app.load('https://prod.spline.design/mEn50a1O-N9ETRqD/scene.splinecode'); */


    const itemsPrefix = ['c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];
    itemsPrefix.forEach((item, index) => {
      const targetEl = document.getElementById('item-' + item);
      let beforeEl;
      console.log('item-' + item);
      if (itemsPrefix[index - 1]) {
        console.log('item-' + itemsPrefix[index - 1]);
        beforeEl = itemsPrefix[index - 1];
      }
      if (targetEl != null) {
        this.createObserver(targetEl, beforeEl);
      }
    });



  }

  /* ngAfterViewInit(){
    this.autoScroll();
  } */

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  createObserver(targetEl: Element, beforeEl: Element) {
    const options = {
      root: null,
      threshold: 0.9
    };

    const that = this;
    const observer = new IntersectionObserver((entries: any[], observer: any) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let $itemsBeforeIn = $('[data-class-in]');
          if ($itemsBeforeIn) {
            $itemsBeforeIn.each((index, item) => {
              let $element = $(item);

              const theClassIn = $element.attr('data-class-in');
              if (theClassIn) {
                $element.removeClass(theClassIn);
              }
            });
          }

          let $itemsBeforeOut = $('[data-class-out]');
          if ($itemsBeforeOut) {
            $itemsBeforeOut.each((index, item) => {
              let $element = $(item);

              const theClassOut = $element.attr('data-class-out');
              if (theClassOut) {
                $element.removeClass(theClassOut);
              }
            });
          }

          let $itemsTargetIn = $('[data-class-in]', targetEl);
          if ($itemsTargetIn){
            const theClassIn = $itemsTargetIn.attr('data-class-in');
            if(theClassIn == 'fixed'){
              this.fixed = true;
            }
            if (theClassIn) {
              $itemsTargetIn.addClass(theClassIn);
            }
          }

          let $itemsTargetOut = $('[data-class-out]', targetEl);
          if ($itemsTargetOut) {
            const theClassOut = $itemsTargetOut.attr('data-class-out');
            if (theClassOut) {
              $itemsTargetOut.addClass(theClassOut);
            }
          }


        }
      });
    }, options);
    observer.observe(targetEl);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    console.log(offset)
  }

  playVideo(){
    const video = this.el.nativeElement.querySelector('.video-one');
    const sectionVideo = this.el.nativeElement.querySelector('.parallax-5');
    video.play();
    this.play = true;
    sectionVideo.classList.add('fixed');
  }

  vidEnded(){
    const sectionOne = this.el.nativeElement.querySelector('.section-items');
    const sectionVideo = this.el.nativeElement.querySelector('.parallax-5');

    this.play = false;
    this.scroll = true;
    
    setTimeout(function(){
      sectionOne.classList.add('up-soled');
      

    }, 500)
  }

  openModal(number: any) {
    this["modal" + number] = true;
  }

  closeModal(number: any) {
    this["modal" + number] = false;
  }
  topPage() {
    window.scrollTo(0, 0);
    const sectionOne = this.el.nativeElement.querySelector('.parallax-1');
    const sectionSix = this.el.nativeElement.querySelector('.section-items');
    const sectionVideo = this.el.nativeElement.querySelector('.parallax-5');
    const video = this.el.nativeElement.querySelector('.video-one');
    const videoInitial = this.el.nativeElement.querySelector('.initial-video');

    sectionOne.scrollIntoView({ behavior: 'smooth' });
    sectionSix.classList.remove('up-soled');
    sectionVideo.classList.remove('fixed');
    this.initialVideo = false;

    video.load();
    videoInitial.load();
    this.fixed = false;
    this.router.navigateByUrl('imagine');
    this.scroll = false;

  }

  playInitialVideo(){
    this.initialVideo = true;
    this.autoScroll();

    const video = this.el.nativeElement.querySelector('.video-one');
    const videoInitial = this.el.nativeElement.querySelector('.initial-video');
    video.play();
    videoInitial.play();
  }

}
